import axiosInstance from './axiosInstance';

const getServicesConfigRates = () =>
  axiosInstance.get('/internal/admin/config/rates');

export default getServicesConfigRates;
